import {useTranslation} from "react-i18next";
import {Box, Button, CircularProgress} from "@mui/material";
import {forwardRef} from "react";

const CustomButton = forwardRef(({
                                     type,
                                     align,
                                     style,
                                     title,
                                     onClick,
                                     children,
                                     className,
                                     startIcon,
                                     height = 55,
                                     hide = true,
                                     margin = "6px 0 0 0",
                                     size = "medium",
                                     color = "primary",
                                     fullWidth = false,
                                     isDisabled = false,
                                     borderRadius = 4,
                                     variant = "contained",
                                     backgroundColor = null,
                                     showCircularProgressIndicator = false,
                                 }, ref) => {
    const {t} = useTranslation();
    const child =
        isDisabled && showCircularProgressIndicator ? (
            <CircularProgress/>
        ) : (
            t(title)
        );

    return (
        hide && (
            <>
                {variant === "text" ? (
                    <Box align={align}>
                        <Button
                            ref={ref}
                            type={type}
                            size={size}
                            color={color}
                            variant={variant}
                            onClick={onClick}
                            disabled={isDisabled}
                            fullWidth={fullWidth}
                            className={className}
                            startIcon={startIcon}
                            style={{
                                borderRadius,
                                ...style,
                            }}
                        >
                            {children ?? child}
                        </Button>
                    </Box>
                ) : (
                    <Button
                        ref={ref}
                        type={type}
                        size={size}
                        color={color}
                        onClick={onClick}
                        variant={variant}
                        disabled={isDisabled}
                        fullWidth={fullWidth}
                        startIcon={startIcon}
                        className={className}
                        style={{
                            ...style,
                            borderRadius,
                            height: height,
                            fontWeight: 600,
                            backgroundColor: backgroundColor,
                            margin: margin,
                        }}
                    >
                        {children ?? child}
                    </Button>
                )}
            </>
        )
    );
});

export default CustomButton;
